import React, { memo } from 'react'
import * as rn from 'react-native'

import * as c from '../../../common'
import * as r from '../../../react-utils'

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Divider from '@mui/material/Divider'
//@ts-ignore
import Fontisto from 'react-native-vector-icons/Fontisto'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Receipt from '@mui/icons-material/Receipt'
import SettingsIcon from '@mui/icons-material/Settings'
import { useParams } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import * as cp from '../../comps'
import * as cpm from '../../../app/components'
import * as gs from '../../../app/gStyles'
import FaqPage from '../../comps/FaqPage'
import FinancingPage from '../../comps/FinancingPage/FinancingPage'
import MainPageReport from '../../comps/MainPageReport'
import MediaImagePages from '../../comps/MediaImagePages'
import Modal from '../../comps/Modal'
import PageReport from '../../comps/PageReport'
import ReleaseLiabilityPage from '../../comps/ReleaseLiabilityPage'
import Signature from '../../comps/Signature'
import generatePDF from '../../helpers/generatePDF'
import { reportTheme } from '../../constants'
import { auth } from '../../fire' // ??
import { contentUser } from '../../helpers/ContentUser'
import { useGetMediaUrls } from '../../hooks/useGetMediaUrls'

import CumComp from './CumComp'
import FinancingCalculator from './FinancingCalculator'
import LoanOptions from './LoanOptions'
import NirvanaContract from './NirvanaContract'
import Summary from './Summary'
//@ts-ignore
import styles from './CustomerReport.module.css'

export default memo(function CustomerReport() {
  // c.debug('<CustomerReport />()')
  const { customerID } = useParams<'customerID'>()
  if (!customerID) {
    throw new ReferenceError(
      `No customerID inside <CustomerReport />. Contact dev dpt.`,
    )
  }

  const t = r.useTheme()

  //#region global
  const { currProducts, toggleHIL, toggleRC, toggleSecurity, toggleSolar } =
    r.useProducts(customerID)
  const totalCostCompany = r.useTotalCost('company', customerID, true)
  const totalCostCustomer = r.useTotalCost('customer', customerID, false)
  //#endregion global

  const [invoiceModal, setInvoiceModal] = React.useState(false)

  // const [lang, setLang] = React.useState<common.Lang>('ENG')

  // const handleLang = React.useCallback(() => {
  //   setLang((current) => (current === 'ENG' ? 'ES' : 'ENG'))
  // }, [setLang])

  const [signatureModalOpen, setSignatureModalOpen] = React.useState(false)
  const [companySignatureModalOpen, setCompanySignatureModalOpen] =
    React.useState(false)
  const [repSignatureModalOpen, setRepSignatureModalOpen] =
    React.useState(false)

  const [hilCompletionSigning, , toggleHILCompletionSigning] = r.useBool(false)

  const [secContractSigningCompanyOpen, , secContractSigningCompanyToggle] =
    r.useBool(false)
  const [secContractSigningCustomerOpen, , secContractSigningCustomerToggle] =
    r.useBool(false)

  const [secCompletionSigning, , toggleSecCompletionSigning] = r.useBool(false)

  const [roofClaimClientSigning, , toggleRoofClaimClientSigning] =
    r.useBool(false)
  const [roofClaimRepSigning, , toggleRoofClaimRepSigning] = r.useBool(false)

  const [solarBill, setSolarBill] = React.useState(0)
  const [powerBill, setPowerBill] = React.useState(0)
  const [alarmBill, setAlarmBill] = React.useState(0)

  const handleSolarBill = React.useCallback(
    (value: string) => {
      setSolarBill(c.parseFloating(value))
    },
    [setSolarBill],
  )

  const handlePowerBill = React.useCallback(
    (value: string) => {
      setPowerBill(c.parseFloating(value))
    },
    [setPowerBill],
  )

  const handleAlarmBill = React.useCallback(
    (value: string) => {
      setAlarmBill(c.parseFloating(value))
    },
    [setAlarmBill],
  )

  // const navigate = useNavigate()

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [includeCoverAndSummary, , toggleCoverAndSummary] = r.useBool(true)
  const [pdfLoading, setPdfLoading] = React.useState(false)
  const [pdfError, setPdfError] = React.useState<string | null>(null)
  const openMenu = Boolean(anchorEl)
  const invoiceUsers = c.useSelector(c.selectInvoiceUsers)

  const openSettings = React.useCallback(
    (event: any) => {
      setAnchorEl(event.currentTarget)
      // document.body.classList.add('remove-scrollbar')
    },
    [setAnchorEl],
  )

  const handleClose = React.useCallback(() => {
    setAnchorEl(null)
  }, [setAnchorEl])

  const openInvoiceModal = React.useCallback(() => {
    handleClose()
    setInvoiceModal(true)
    document.body.classList.add('remove-scrollbar')
  }, [handleClose, setInvoiceModal])

  React.useEffect(() => void c.dispatch(c.efficiencyPricesAction()), [])

  // TODO: Customer edit subscription still on when this happens?
  React.useEffect((): c.VoidFn => {
    c.dispatch(
      c.subToSingleCustomer({
        customerID: customerID,
      }),
    )
    return () => {
      c.dispatch(
        c.unSubFromSingleCustomer({
          customerID,
        }),
      )
    }
  }, [customerID])

  const customer = c.useSelector(
    (_): c.Customer =>
      _.customers.data[customerID] ||
      c.createEmptyCustomer({
        firebaseKey: customerID,
      }),
  )

  const { contractCompanyFull } = r.useContractCompany(customerID)

  const {
    c_signature_date,
    c_signature,
    customerAddress,
    // customerEmail,
    customerName,
    homeRep,
    report_company_signature_date,
    report_company_signature,
    solarCompany,
    solarRep,
    sort_key,
  } = customer

  const state = c.getCompanyState(solarCompany)

  //#region sharedContractNirvana
  const [
    sendToCustomerOpenVal,
    sendToCustomerOpenSet,
    sendToCustomerOpenToggle,
  ] = r.useBool(false)
  const [
    sendToCustomerIsGeneratingContractVal,
    sendToCustomerIsGeneratingContractSet,
  ] = React.useState(false)

  const sendToCustomerHandleCopy = React.useCallback(() => {
    const link = `https://nirvana.ecohomereports.com/contract/${customerID}`

    navigator.clipboard.writeText(link)
    window.alert('Link has been copied to clipboard')
  }, [customerID])

  const sendToCustomerHandle = React.useCallback(() => {
    sendToCustomerIsGeneratingContractSet(true)
    /**
     * All sensitive data is truncated, as these shared contracts will
     * be publicly accessible
     */
    const newSharedContract: c.SharedContractNirvana = {
      amountFinance: customer.report_nirvana_finance,
      amountUpfront: customer.report_nirvana_upfront,
      amountRemaining: customer.report_nirvana_remaining,
      contractCompanyAddress1: contractCompanyFull.address1,
      contractCompanyAddress2: contractCompanyFull.address2,
      contractCompanyEmail: contractCompanyFull.email,
      contractCompanyLogo: contractCompanyFull.logo,
      contractCompanyLongName: contractCompanyFull.longName,
      contractCompanyPhoneNumber: contractCompanyFull.phoneNumber,
      contractCompanyRoofingLicense: contractCompanyFull.roofingLicense,
      contractCompanyShortName: contractCompanyFull.shortName,
      contractCompanyStates: contractCompanyFull.states,
      customerAddress: customer.customerAddress,
      customerEmail: customer.customerEmail,
      customerName: customer.customerName,
      customerPhone: customer.customerPhone,
      customerPhoneAlt: customer.customerPhoneAlt,
      customerSigned: false,
      repName: customer.homeRep,
      rows: c.buildContractRows(customer),
      state: customer.solarCompany,
      totalCostCustomer,
    }
    c.getDatabase()
      .ref('Contract/' + customerID)
      .set(newSharedContract)
      .then(() => {
        sendToCustomerOpenSet(true)
      })
      .catch((e) => {
        window.alert(`Error sending contract to customer: ${c.processErr(e)}`)
      })
      .finally(() => {
        sendToCustomerIsGeneratingContractSet(false)
      })
  }, [
    contractCompanyFull.address1,
    contractCompanyFull.address2,
    contractCompanyFull.email,
    contractCompanyFull.logo,
    contractCompanyFull.longName,
    contractCompanyFull.phoneNumber,
    contractCompanyFull.roofingLicense,
    contractCompanyFull.shortName,
    contractCompanyFull.states,
    customer,
    customerID,
    sendToCustomerOpenSet,
    totalCostCustomer,
  ])
  //#endregion

  const handleDownloadPdf = React.useCallback(async () => {
    handleClose()
    setPdfError(null)
    setPdfLoading(true)
    await new Promise((r) => requestAnimationFrame(r))
    try {
      await generatePDF(customerName)
    } catch (e) {
      setPdfError(c.processErr(e))
    } finally {
      setPdfLoading(false)
    }
  }, [customerName, handleClose])

  const dismissPdfError = React.useCallback(() => {
    setPdfError(null)
  }, [])

  const isInvoiceUser = React.useMemo(() => {
    const authUser = auth?.currentUser?.email
    if (!authUser) return false

    const _authUser = authUser.replace('.com', '')

    if (!invoiceUsers) return false

    const invoiceUser = invoiceUsers[_authUser]

    if (invoiceUser && (solarCompany === 'CPS' || solarCompany === 'NPS'))
      return true
    return false
  }, [invoiceUsers, solarCompany])

  const selectAllCustomerMedia = React.useMemo(
    () => c.makeSelectAllCustomerMedia(),
    [],
  )
  const selectAllCustomerMediaArgs = React.useMemo(
    (): c.SelectAllCustomerMediaParams => ({
      // TODO
      customerID: customerID || '',
    }),
    [customerID],
  )

  const allCustomerMedia = c.useSelector((_) =>
    selectAllCustomerMedia(_, selectAllCustomerMediaArgs),
  )

  const [ownerHouseMain] = c.values(allCustomerMedia.owner_house)
  const [ownerHouse = ownerHouseMain] = c.values(
    allCustomerMedia.rc_front_house,
  )

  const ownerHousePropB = React.useMemo((): readonly c.MediaData[] => {
    if (ownerHouse) {
      return [
        {
          type: 'img',
          url: c.getMediaItemSrc(ownerHouse),
        },
      ]
    }
    return c.EMPTY_ARRAY
  }, [ownerHouse])

  const contentUserType = contentUser(homeRep as string)

  const otherAreasPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'problem',
  ) as c.MediaData[]

  const atticPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'insulation',
  ) as c.MediaData[]

  const hvacPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'hvac_system',
  ) as c.MediaData[]
  const thermalPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'thermal',
  ) as c.MediaData[]

  const electricityPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'electricity',
  ) as c.MediaData[]
  const allExteriorWallsPics = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'all_exterior_walls_site_survey',
  ) as c.MediaData[]
  const raftersPics = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rafters_site_survey',
  ) as c.MediaData[]
  const allPlanesRoofPics = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'all_planes_roof_site_survey',
  ) as c.MediaData[]
  const electricalPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'electrical',
  ) as c.MediaData[]
  const electricalOldPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'electrical_panel_site_survey',
  ) as c.MediaData[]
  const otherSolarSurveyPics = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'other_site_survey',
  ) as c.MediaData[]
  const adjustmentPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'adders',
  ) as c.MediaData[]

  const otherDocumentsPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'other_documents',
  ) as c.MediaData[]

  const idPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'id',
  ) as c.MediaData[]

  const roofPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'roof',
  ) as c.MediaData[]

  const solarProposalPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'solar_proposal',
  ) as c.MediaData[]

  const windowsPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'windows',
  ) as c.MediaData[]

  const RCFrontHousePictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_front_house',
  ) as c.MediaData[]

  const RC3DViewPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_3d_view',
  ) as c.MediaData[]

  const RCAddressVerificationPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_address_verification',
  ) as c.MediaData[]

  const RCDripEdgePictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_drip_edge',
  ) as c.MediaData[]

  const RCFlashingsPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_flashings',
  ) as c.MediaData[]

  const RCGuttersPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_gutters',
  ) as c.MediaData[]

  const RCHailPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_hail',
  ) as c.MediaData[]

  const RCLayersPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_layers',
  ) as c.MediaData[]

  const RCLengthShinglePictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_length_shingle',
  ) as c.MediaData[]

  const RCOtherPropertyPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_other_property_wind_damage',
  ) as c.MediaData[]

  const RCWindDamagesPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_wind_damages',
  ) as c.MediaData[]

  const RCPenetrationsPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_penetrations',
  ) as c.MediaData[]

  const RCInclinationPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_roof_inclination',
  ) as c.MediaData[]

  const RCOverviewPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_roof_overview',
  ) as c.MediaData[]

  const RCShinglesColorPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_shingles_color',
  ) as c.MediaData[]

  const RCGaragePictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_garage',
  ) as c.MediaData[]

  const RCIceShieldPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_ice_shield',
  ) as c.MediaData[]

  const RCSidingPictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_siding',
  ) as c.MediaData[]

  const RCWiresHomePictures = useGetMediaUrls(
    'images-videos',
    customerID as string,
    'rc_wires_home',
  ) as c.MediaData[]

  React.useEffect((): c.EmptyFn => {
    c.dispatch(c.subToCustomerMedia({ customerID }))

    return (): void => {
      c.dispatch(
        c.unSubFromCustomerMedia({
          customerID,
        }),
      )
    }
  }, [customerID])

  const toggleSignatureModal = React.useCallback(() => {
    setSignatureModalOpen((current) => !current)
  }, [setSignatureModalOpen])

  const toggleCompanySignatureModal = React.useCallback(() => {
    setCompanySignatureModalOpen((current) => !current)
  }, [setCompanySignatureModalOpen])

  const toggleRepSignatureModal = React.useCallback(() => {
    setRepSignatureModalOpen((current) => !current)
  }, [setRepSignatureModalOpen])

  const settingsIconStyle = React.useMemo(
    () => ({
      color: c.companyColors[solarCompany],
      cursor: 'pointer',
      fontSize: '72px',
    }),
    [solarCompany],
  )

  // React.useEffect(() => {
  //   const res = verifyEmptyFields(customer)

  //   if (res.empty) {
  //     navigate(`/customers/${customerID}#${res.targetScroll}`)
  //   }
  // }, [customer, customerID, navigate])

  React.useEffect(() => {
    if (
      invoiceModal ||
      companySignatureModalOpen ||
      repSignatureModalOpen ||
      signatureModalOpen
    ) {
      document.body.addEventListener('wheel', handleWheelEvent)
      document.body.addEventListener('keydown', handleKeyEvent)
    }
    return () => {
      document.body.removeEventListener('wheel', handleWheelEvent)
      document.body.removeEventListener('keydown', handleKeyEvent)
    }
  }, [
    companySignatureModalOpen,

    invoiceModal,
    repSignatureModalOpen,
    signatureModalOpen,
  ])

  if (!customerID) {
    return null
  }

  const pages = (
    <>
      <PageReport
        company={solarCompany}
        isPDF={pdfLoading}
        noPDF={!includeCoverAndSummary}
        vPadDisable
      >
        <MainPageReport
          customerAddress={customerAddress}
          customerID={customerID}
          customerName={customerName}
          homeRep={homeRep}
          houseViewPic={ownerHouse && c.getMediaItemSrc(ownerHouse)}
          isPDF={pdfLoading}
          solarCompany={solarCompany}
          solarRep={solarRep}
          sortKey={sort_key}
        />
      </PageReport>

      <Summary noPDF={!includeCoverAndSummary} isPDF={pdfLoading} />

      {/* MAIN FINANCING PAGE, the one with the pie chart */}
      {c.CODENAME !== 'glow' &&
        (currProducts.includes('Solar') || currProducts.length === 0) && (
          <FinancingPage
            alarmBill={alarmBill}
            company={solarCompany}
            contentUser={contentUserType}
            handleAlarmBill={handleAlarmBill}
            handlePowerBill={handlePowerBill}
            handleSolarBill={handleSolarBill}
            isPDF={pdfLoading}
            powerBill={powerBill}
            solarBill={solarBill}
            solarCompany={solarCompany}
            totalFinance={totalCostCompany}
          />
        )}

      {(currProducts.includes('HIL') || currProducts.length === 0) && (
        <PageReport
          autoHeight
          company={solarCompany}
          companyBorder
          isPDF={pdfLoading}
          noPDF
          title="Loan Options"
        >
          <LoanOptions />
        </PageReport>
      )}

      {/* FAQ  */}
      {contentUserType === 'SOLAR' ? (
        <PageReport
          company={solarCompany}
          companyBorder
          isPDF={pdfLoading}
          title="Faq"
        >
          <FaqPage />
        </PageReport>
      ) : //   </AccordionDetails>
      // </Accordion>
      null}

      {c.CODENAME !== 'glow' &&
        (currProducts.includes('Solar') || currProducts.length === 0) &&
        state !== 'nevada' && (
          <PageReport
            company={solarCompany}
            companyBorder
            isPDF={pdfLoading}
            noPDF
            title="Cumulative Comparison"
          >
            <CumComp />
          </PageReport>
        )}

      {/* FINANCING CALCULATOR */}
      {c.CODENAME !== 'glow' &&
        c.CODENAME !== 'nirvana' &&
        (currProducts.includes('Solar') || currProducts.length === 0) && (
          <PageReport
            autoHeight
            company={solarCompany}
            companyBorder={false}
            isPDF={pdfLoading}
            noPDF
          >
            <FinancingCalculator
              alarmBill={alarmBill}
              contentUser={contentUserType}
              energyBill={powerBill}
              solarBill={solarBill}
            />
          </PageReport>
        )}

      {/* Cumulative comparison */}

      {/* FAQ  */}
      {contentUserType === 'SOLAR' && c.CODENAME !== 'glow' ? (
        <PageReport
          company={solarCompany}
          companyBorder
          isPDF={pdfLoading}
          title="Faq"
        >
          <FaqPage />
        </PageReport>
      ) : null}

      {false && c.IS_MAIN && (
        <PageReport
          autoHeight
          company={solarCompany}
          companyBorder
          isPDF={pdfLoading}
          title="Service Agreement"
        >
          <ReleaseLiabilityPage
            customerID={customerID as string}
            //
            c_signature={c_signature}
            c_signature_date={c_signature_date}
            //
            reportCompanySignature={report_company_signature}
            reportCompanySignDate={report_company_signature_date}
            //
            solarCompany={solarCompany}
            //
            toggleCompanySignatureModal={toggleCompanySignatureModal}
            toggleSignatureModal={toggleSignatureModal}
          />
        </PageReport>
      )}

      {c.CODENAME === 'nirvana' && (
        <NirvanaContract
          customerID={customerID}
          isPDF={pdfLoading}
          toggleSignatureModal={toggleSignatureModal}
          toggleCompanySignatureModal={toggleCompanySignatureModal}
        />
      )}

      <MediaImagePages
        isPDF={pdfLoading}
        houseViewPictures={ownerHousePropB}
        // Assessment
        atticPictures={atticPictures}
        roofPictures={roofPictures}
        windowPictures={windowsPictures}
        hvacPictures={hvacPictures}
        otherAreasPictures={otherAreasPictures}
        // Documentation
        idPictures={idPictures}
        otherDocumentsPictures={otherDocumentsPictures}
        // Solar Survey
        thermalPictures={thermalPictures}
        solarProposalPictures={solarProposalPictures}
        electricityPictures={electricityPictures}
        allExteriorWallsPics={allExteriorWallsPics}
        raftersPics={raftersPics}
        allPlanesRoofPics={allPlanesRoofPics}
        electricalPictures={electricalPictures}
        otherSolarSurveyPics={otherSolarSurveyPics}
        adjustmentPictures={adjustmentPictures}
        electricalOldPictures={electricalOldPictures}
        // Roof Claims
        rcFrontHousePictures={RCFrontHousePictures}
        rcAddressVerificationPictures={RCAddressVerificationPictures}
        rc3DViewPictures={RC3DViewPictures}
        rcGaragePics={RCGaragePictures}
        rcWiresHomePictures={RCWiresHomePictures}
        rcSlidingPictures={RCSidingPictures}
        rcLayersPictures={RCLayersPictures}
        rcInclinationPictures={RCInclinationPictures}
        rcRoofOverviewPictures={RCOverviewPictures}
        rcDripEdgePictures={RCDripEdgePictures}
        rcGuttersPictures={RCGuttersPictures}
        rcIceShieldPics={RCIceShieldPictures}
        rcFlashingsPictures={RCFlashingsPictures}
        rcPenetrationsPictures={RCPenetrationsPictures}
        rcHailPictures={RCHailPictures}
        rcPropertyDamagesPics={RCOtherPropertyPictures}
        rcWindDamagesPics={RCWindDamagesPictures}
        rcShingleLengthPics={RCLengthShinglePictures}
        rcShinglesColorPics={RCShinglesColorPictures}
        //
      />
    </>
  )

  return (
    <ThemeProvider theme={reportTheme}>
      <>
        <CssBaseline />
        {(pdfLoading || pdfError) && (
          <div
            aria-busy={pdfLoading}
            aria-live="assertive"
            className={styles['pdf-splash']}
            role="status"
          >
            <div className={styles['pdf-splash-card']}>
              {pdfLoading ? (
                <>
                  <CircularProgress size={56} />
                  <p className={styles['pdf-splash-title']}>Generating PDF</p>
                  <p className={styles['pdf-splash-message']}>
                    Please wait while we prepare the customer report.
                  </p>
                </>
              ) : (
                <>
                  <p className={styles['pdf-splash-title']}>
                    PDF generation failed
                  </p>
                  <p className={styles['pdf-splash-error']}>
                    {pdfError || 'Unexpected error while generating the PDF.'}
                  </p>
                  <Button onClick={dismissPdfError} variant="contained">
                    Dismiss
                  </Button>
                </>
              )}
            </div>
          </div>
        )}
        {pages}
        <cp.Breadcrumbs />
        <div className={styles['menu-pdf']}>
          <SettingsIcon onClick={openSettings} sx={settingsIconStyle} />
          <Menu
            anchorEl={anchorEl}
            anchorOrigin={anchorOrigin}
            aria-labelledby="demo-positioned-button"
            id="demo-positioned-menu"
            onClose={handleClose}
            open={openMenu}
            sx={sx['menuPdfOptions']}
            transformOrigin={menuTransformOrigin}
          >
            {c.CODENAME !== 'nirvana' && (
              <MenuItem onClick={toggleSecurity}>
                {currProducts.includes('Security') ? (
                  <Fontisto
                    color={t.backdrop.highlight}
                    name="checkbox-active"
                  />
                ) : (
                  <Fontisto
                    color={t.backdrop.color as string}
                    name="checkbox-passive"
                  />
                )}

                {gs.colGap8}

                <cpm.Text colorScheme="light">Alarms</cpm.Text>
              </MenuItem>
            )}

            <MenuItem onClick={toggleSolar}>
              {currProducts.includes('Solar') ? (
                <Fontisto color={t.backdrop.highlight} name="checkbox-active" />
              ) : (
                <Fontisto
                  color={t.backdrop.color as string}
                  name="checkbox-passive"
                />
              )}

              {gs.colGap8}

              <cpm.Text colorScheme="light">Solar</cpm.Text>
            </MenuItem>
            <MenuItem onClick={toggleHIL}>
              {currProducts.includes('HIL') ? (
                <Fontisto color={t.backdrop.highlight} name="checkbox-active" />
              ) : (
                <Fontisto
                  color={t.backdrop.color as string}
                  name="checkbox-passive"
                />
              )}

              {gs.colGap8}

              <cpm.Text colorScheme="light">Home Improvements</cpm.Text>
            </MenuItem>
            {false && c.CODENAME !== 'nirvana' && (
              <MenuItem onClick={toggleRC}>
                {currProducts.includes('RC') ? (
                  <Fontisto
                    color={t.backdrop.highlight}
                    name="checkbox-active"
                  />
                ) : (
                  <Fontisto
                    color={t.backdrop.color as string}
                    name="checkbox-passive"
                  />
                )}

                {gs.colGap8}

                <cpm.Text colorScheme="light">Roof Claims</cpm.Text>
              </MenuItem>
            )}

            <Divider />

            <MenuItem
              disabled={sendToCustomerIsGeneratingContractVal}
              onClick={sendToCustomerHandle}
            >
              <Fontisto
                name={
                  sendToCustomerIsGeneratingContractVal ? 'spinner' : 'share-a'
                }
              />
              {gs.colGap8}
              <cpm.Text colorScheme="light">Send to customer</cpm.Text>
            </MenuItem>

            <Divider />
            <MenuItem onClick={toggleCoverAndSummary}>
              <Fontisto
                color={
                  includeCoverAndSummary
                    ? t.backdrop.highlight
                    : (t.backdrop.color as string)
                }
                name={
                  includeCoverAndSummary
                    ? 'checkbox-active'
                    : 'checkbox-passive'
                }
              />

              {gs.colGap8}

              <cpm.Text colorScheme="light">
                Include cover &amp; summary
              </cpm.Text>
            </MenuItem>

            <MenuItem disabled={pdfLoading} onClick={handleDownloadPdf}>
              <Fontisto name="download" />

              {gs.colGap8}

              <cpm.Text colorScheme="light">Download PDF</cpm.Text>
            </MenuItem>

            {isInvoiceUser && (
              <MenuItem onClick={openInvoiceModal} sx={sx['openInvoice']}>
                <Receipt sx={sx['pdfIcon']} /> Open invoice
              </MenuItem>
            )}
          </Menu>
        </div>
        <Modal
          open={hilCompletionSigning}
          onRequestClose={toggleHILCompletionSigning}
        >
          <Signature
            customerID={customerID}
            field="hil_completion_client_sign"
            onRequestClose={toggleHILCompletionSigning}
          />
        </Modal>
        <Modal
          open={secCompletionSigning}
          onRequestClose={toggleSecCompletionSigning}
        >
          <Signature
            customerID={customerID}
            field="security_completion_sign_customer"
            onRequestClose={toggleSecCompletionSigning}
          />
        </Modal>
        <Modal
          open={secContractSigningCompanyOpen}
          onRequestClose={secContractSigningCompanyToggle}
        >
          <Signature
            customerID={customerID}
            field="security_contract_sign_company"
            onRequestClose={secContractSigningCompanyToggle}
          />
        </Modal>
        <Modal
          open={secContractSigningCustomerOpen}
          onRequestClose={secContractSigningCustomerToggle}
        >
          <Signature
            customerID={customerID}
            field="security_contract_sign_customer"
            onRequestClose={secContractSigningCustomerToggle}
          />
        </Modal>
        <Modal
          onRequestClose={toggleRoofClaimClientSigning}
          open={roofClaimClientSigning}
        >
          <Signature
            customerID={customerID}
            field="roof_claiming_client_sign"
            onRequestClose={toggleRoofClaimClientSigning}
          />
        </Modal>
        <Modal
          onRequestClose={toggleRoofClaimRepSigning}
          open={roofClaimRepSigning}
        >
          <Signature
            customerID={customerID}
            field="roof_claiming_company_rep_sign"
            onRequestClose={toggleRoofClaimRepSigning}
          />
        </Modal>
        <Modal open={signatureModalOpen} onRequestClose={toggleSignatureModal}>
          <Signature
            customerID={customerID}
            field="c_signature"
            onRequestClose={toggleSignatureModal}
          />
        </Modal>
        <Modal
          open={companySignatureModalOpen}
          onRequestClose={toggleCompanySignatureModal}
        >
          <Signature
            customerID={customerID}
            field="report_company_signature"
            onRequestClose={toggleCompanySignatureModal}
          />
        </Modal>
        <Modal
          open={repSignatureModalOpen}
          onRequestClose={toggleRepSignatureModal}
        >
          <Signature
            customerID={customerID}
            field="r_signature"
            onRequestClose={toggleRepSignatureModal}
          />
        </Modal>

        <cp.Dialog
          onClose={sendToCustomerOpenToggle}
          open={sendToCustomerOpenVal}
          title="Send contract to customer"
        >
          <SendToCustomerModal
            customerID={customerID}
            customerEmail={customer.customerEmail}
            onClickCopy={sendToCustomerHandleCopy}
          />
        </cp.Dialog>
        <ToastContainer
          position="top-left"
          autoClose={1300}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    </ThemeProvider>
  )
})

export const dateToNumber = (date: string) => {
  if (date !== 'mm/dd/yyyy') {
    return Date.parse(date).toString()
  } else {
    return '0'
  }
}

const anchorOrigin = {
  horizontal: 'left',
  vertical: 'top',
} as const

const menuTransformOrigin = {
  horizontal: 'right',
  vertical: 'top',
} as const

export interface ConsolidationDebtDataExtend extends c.ConsolidationDebtData {
  address: string
  closer: string
  creditScore: string
  notes: string
}

export const rootSurfaceCustomerReport: c.Surface = 'pasteboard'
const sx = {
  menuPdfOptions: {
    marginRight: '20px',
  },
  openInvoice: {
    alignItems: 'center',
    color: '#2626f1',
    display: 'flex',
    textAlign: 'center',
    textDecoration: 'underline',
    width: '100%',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  pdfIcon: {
    height: '20px',
    width: '20px',
  },
  settingsIcon: {
    color: 'pink',
    cursor: 'pointer',
    fontSize: '72px',
  },
}

const handleWheelEvent = (e: any) => {
  e.preventDefault()
}

const handleKeyEvent = (e: any) => {
  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
    e.preventDefault()
  }
}

type SendToCustomerModalProps = c.r<{
  customerEmail: string
  customerID: string
  onClickCopy: () => void
}>

const SendToCustomerModal: React.FC<SendToCustomerModalProps> = React.memo(
  ({ customerEmail, customerID, onClickCopy }) => {
    const gStyles = gs.useGlobalStyles('canvas')
    const rowGap = gs.useRowGap('canvas')

    const link = `https://nirvana.ecohomereports.com/contract/${customerID}`

    return (
      <rn.View>
        <rn.View style={gStyles.contentHorizontal}>
          {rowGap}
          <cpm.TextInput
            clearButtonMode="always"
            // TODO - make this a copyable field
            // Keep editable styling (readable text)
            // editable={false}
            label="Customer email address"
            on="canvas"
            shrink
            value={customerEmail}
          />
          {rowGap}
        </rn.View>
        {gs.rowGap16}
        <rn.View style={gStyles.separatorH} />
        {gs.rowGap16}

        <rn.View style={gStyles.contentHorizontal}>
          <cpm.TextInput
            clearButtonMode="always"
            // TODO - make this a copyable field
            // Keep editable styling (readable text)
            // editable={false}
            label="Shareable link"
            on="canvas"
            shrink
            value={link}
          />
        </rn.View>

        {gs.rowGap16}
        <rn.View style={gStyles.separatorH} />
        {gs.rowGap16}

        <rn.View style={buttonsStyle}>
          <cpm.Button disabled on="canvas" onPress={c.emptyFn}>
            Send to e-mail (coming soon)
          </cpm.Button>

          {rowGap}

          <cpm.Button on="canvas" onPress={onClickCopy}>
            Copy link
          </cpm.Button>
        </rn.View>
      </rn.View>
    )
  },
)
const buttonsStyle = {
  ...gs.rowSpaceAround100,
  flexWrap: 'wrap',
  gap: c.light.canvas.gap,
} as const
